// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { cloud16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-cloud': IconCloud;
    }
}

/**
 * The icon component for the 'cloud' icon
 */
export class IconCloud extends Icon {
    public constructor() {
        super(cloud16X16);
    }
}

registerIcon('icon-cloud', IconCloud);
export const iconCloudTag = 'nimble-icon-cloud';
